import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import Moment, * as moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppState } from '../../core';
import { LocationLogRecord } from '../../core/models/location-log-record';
import { PostProcessingService } from '../../core/services';
import { editTableColumnProximity } from '../../shared/components/proximity-modal/proximity-modal.component';
import { StatMetric, TableColumn, TableViewComponentBase, TableViewQueryRequest } from '../../shared/components/table-view/table-view-component-base';
import { LocationLogsTableCellComponent } from './location-logs-table-cell.component';
momentDurationFormatSetup(moment);



@Component({
  selector: 'app-location-logs',
  templateUrl: '../../shared/components/table-view/table-view.component.html',
  styleUrls: [
    '../../shared/components/table-view/scss/table-view.scss',
    '../../shared/components/table-view/scss/app-tab-full-height.scss',
    '../../shared/components/table-view/scss/fixed-headers-and-column.scss'
  ]
})
export class LocationLogsComponent extends TableViewComponentBase<LocationLogRecord> implements OnInit, OnDestroy {


  constructor(
      appState: AppState,
      modalService: BsModalService,
      public postProcessingService: PostProcessingService,
      elementRef: ElementRef,
      datePipe: DatePipe
  ){
    super(appState,modalService,elementRef,datePipe)
    this.tableCellRenderer = LocationLogsTableCellComponent
    const proximityColumn: TableColumn = { title:'Proximity (m)', name: 'proximitymeters', visible: true };
    proximityColumn.filterEditFn = async (newValSetter) => this.editProximity(proximityColumn,newValSetter);
    this.tableColumns  = [
      { title:'View Row ID', name: 'viewrowid', visible: false},
      { title:'Stage', name: 'stage', visible: true},
      { title:'Loc Provider', name: 'locationprovider', visible: true},
      { title:'Type', name: 'type', visible: true},
      { title:'Call Source ID', name: 'callsourceid', visible: false, template: 'callLink' },
      { title:'Correlated?', name: 'callstarttime', visible: true, template: 'correlationLink', timeZone: 'utc'},

      { title:'Volunteer ID', name: 'volunteerid', visible: false},
      { title:'Handset Type', name: 'handsettype', visible: false},
      { title:'Handset ID', name: 'handsetid', visible: false},

      { title:'Handset IMEI', name: 'imei', visible: true},
      { title:'Phone Number', name: 'phonenum', visible: true},
      { title:'Location Source ID', name: 'sourceid', visible: false, template: 'locationLink' },
      { title:'Location Time (UTC)', name: 'locationtime', visible: true, template: 'fulltime', smallNullSort: true },
      { title:'Correlation Time (UTC)', name: 'correlationtime', visible: true, smallNullSort: true},
      { title:'Latitude', name: 'latitude', visible: true, template: 'latlng'},
      { title:'Longitude', name: 'longitude', visible: true, template: 'latlng'},
      { title:'Nearest Building', name: 'nearestbuildingid', visible: false, sortable: false, filterable: false },
      { title:'Nearest Building Distance (m)', name: 'nearestbuildingdistance', visible: false, sortable: false, filterable: false, template: 'number' },
      proximityColumn,
      { title:'Horiz Uncertainty', name: 'uncertaintyhoriz', visible: true},
      { title:'Altitude', name: 'altitude', visible: true},
      { title:'Vert Uncertainty', name: 'uncertaintyvert', visible: true},
      { title:'Technology', name: 'technology', visible: true},
      { title:'Import File ID', name: 'importfileid', visible: false },
      { title:'Source Table', name: 'sourcetable', visible: true, template: 'locationLink'},
      { title:'Source Filename', name: 'filename', visible: true},
    ];
    const metrics: StatMetric[] = [
      { column: 'altitude', format: { dataType: 'number' }, statTypes: ['min','max','avg']},
      { column: 'uncertaintyhoriz', statTypes: ['min','max','avg']},
      { column: 'uncertaintyvert', format: { dataType: 'number' }, statTypes: ['min','max','avg']},
      { column: 'locationtime', format: { dataType: 'date' }, statTypes: ['min','max']},
      { column: '*', format: { dataType: 'number' }, statTypes: ['count']},
    ]
    this.statGroups = [
      {
        id: 'locationprovider',
        groupBy: ['locationprovider'],
        visible: true,
        metrics,
      },
      {
        id: 'type',
        groupBy: ['type'],
        visible: false,
        metrics,
      },
      {
        id: 'stage',
        groupBy: ['stage'],
        visible: false,
        metrics,
      },
      {
        id: 'technology',
        groupBy: ['technology'],
        visible: false,
        metrics,
      },
    ]

    this.sortColumns = [
      { key: 'locationtime', order: 'DESC', smallNulls: true},
    ];
    this.pageSize = 100;
  }

  editProximity = async (column: TableColumn, newValSetter: (newVal:string)=>void) =>
    editTableColumnProximity(this,column,newValSetter);
  ngOnInit(): void {
    this.init()
  }


  ngOnDestroy(): void {
    this.destroy()
  }

  // Used during export when formating data cell
  isDateColumn = ( column : TableColumn ) => {
    return column.template == 'time' || column.name == 'callstarttime'
  }

  doQuery = async ( queryReq : TableViewQueryRequest ) => {
    const results = await this.postProcessingService.findLocationLogRecords(queryReq);
    if ( ['correlationtime','locationtime'].includes(queryReq.sorts?.[0]?.key) ) {
      const rows = results.rows;
      for( let i=1; i < rows?.length; i++ ) {
        try {
          const row = rows[i];
          const duration = Moment.duration(Moment(rows[i-1].correlationtime).diff(Moment(row.correlationtime)));
          row['callGapSecs'] = (duration as any).format('D [days] h:mm:ss', {trim: 'left'})
        } catch ( e: any ) {
          console.warn('Failed computing call gap seconds for rows',i-1, i);
        }
      }
    }
    return results;
  }


  getName = () => 'location-logs'

}
